/**
 * App-level role hierarchy: user (default), curator, manager, admin, superadmin.
 * superadmin is a strict superset of admin — every admin-gated UI accepts
 * superadmin too. Keep these helpers as the single source of truth so a future
 * role tier (or rename) only needs editing here, and so we never accidentally
 * lock the Portal owner out of admin features.
 *
 * NOTE: club membership roles (owner / admin / member) are a separate domain —
 * those live on ClubMembership.Role and use their own gating in ClubHeader,
 * ClubAnnouncementCard, etc. Don't conflate the two.
 */

export function normalizeRole(role) {
  return (role || '').toLowerCase();
}

export function isAppAdmin(role) {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin';
}

export function isSuperadmin(role) {
  return normalizeRole(role) === 'superadmin';
}

export function isManagerOrAdmin(role) {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin' || r === 'manager';
}

export function isCuratorOrAbove(role) {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin' || r === 'manager' || r === 'curator';
}

export function isSuperadminOrAdmin(role) {
  // Alias for clarity at Portal-gated call sites — semantically same as
  // isAppAdmin, but reads naturally next to "RequireSuperadmin" etc.
  return isAppAdmin(role);
}
